import Page from '../../layout/Page'
import SettingsPageContent from './SettingsPageContent'

const SettingsPage = () => <Page content={<SettingsPageContent />} />

export default SettingsPage
